import ko from "knockout";
import { registerKnockoutBinding } from "flow/knockout/register";

registerKnockoutBinding("nullableNumericValue", {
    init: function (
        element: HTMLElement,
        valueAccessor: () => any,
        allBindingsAccessor: KnockoutAllBindingsAccessor,
        viewModel: any,
        bindingContext: KnockoutBindingContext
    ) {
        let underlyingObservable: any;
        let precision = 2;
        if (valueAccessor().precision != undefined && valueAccessor().value != undefined) {
            underlyingObservable = valueAccessor().value;
            precision = valueAccessor().precision;
        } else {
            underlyingObservable = valueAccessor();
        }
        const newValueAccessor = () => {
            return underlyingObservable.extend({ nullableNumeric: precision });
        };

        ko.bindingHandlers.value.init(element, newValueAccessor, allBindingsAccessor, viewModel, bindingContext);
    },
    update: ko.bindingHandlers.value.update
});
